import { render, staticRenderFns } from "./SkillProfiles.vue?vue&type=template&id=39104158&"
import script from "./SkillProfiles.vue?vue&type=script&lang=js&"
export * from "./SkillProfiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports